/**
 * Helpers for number inputs that clear a displayed 0 on focus.
 */

export function toDisplayValue(value, scale = 1) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return parseFloat((n * scale).toFixed(4));
}

/** True for 0, 0.0, "0", "0.0", "0.00", etc. */
export function isEffectivelyZero(display) {
  if (display === '' || display == null) return true;
  const n = typeof display === 'number' ? display : Number(String(display).trim());
  return Number.isFinite(n) && n === 0;
}

export function draftOnFocus(display) {
  return isEffectivelyZero(display) ? '' : String(display);
}

/**
 * Keep an in-progress empty/"." draft when the stored value is still 0.
 * Otherwise a parent re-render snaps the field back to "0" while typing.
 */
export function reconcileDraft(current, value, scale = 1) {
  if (current === null) return null;
  const incoming = toDisplayValue(value, scale);
  if (current === '' || current === '-' || current === '.' || current === ',') {
    return isEffectivelyZero(incoming) ? current : null;
  }
  const parsed = parseFloat(String(current).replace(',', '.'));
  if (Number.isFinite(parsed) && Math.abs(parsed - incoming) < 1e-6) return current;
  return null;
}

export function commitDraft(raw, scale = 1, { min, max } = {}) {
  const parsed = parseFloat(raw);
  let nextDisplay = Number.isFinite(parsed) ? parsed : 0;
  if (max !== undefined) nextDisplay = Math.min(max, nextDisplay);
  if (min !== undefined) nextDisplay = Math.max(min, nextDisplay);
  return nextDisplay / scale;
}
